import { render, staticRenderFns } from "./EditSpecialPrecautions.vue?vue&type=template&id=29acba06&"
import script from "./EditSpecialPrecautions.vue?vue&type=script&lang=js&"
export * from "./EditSpecialPrecautions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports